import { Activity, memo, useEffect, useMemo, useState } from 'react';
// import { memo, useLayoutEffect, useState } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import NavItem from './NavItem';
import NavGroup from './NavGroup';
import { MenuOrientation } from 'config';
//import menuItems from 'menu-items';
import baseMenuItems from 'menu-items';
import useConfig from 'hooks/useConfig';
//import useAuth from 'hooks/useAuth';
//import { ROLES } from '../../../constants/roles';

// import { Menu } from 'menu-items/widget';
import { HORIZONTAL_MAX_ITEM } from 'config';
import { useGetMenuMaster } from 'api/menu';

// types
import { NavItemType } from 'types';

import { useProjects } from 'contexts/projects/useProjects';
import { buildProjectSection } from 'menu-items/project-section';
import { viewpointNumber } from 'utils/viewpoint';


// ==============================|| SIDEBAR MENU LIST ||============================== //

function MenuList() {
  //const { appUser } = useAuth();
  //const role = appUser?.roles?.[0] ?? '';
  //console.log(role);
  const downMD = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));


  //const { items } = getMenuItems();
  const { items: baseItems } = baseMenuItems();
  const { activeProject, activeRunId } = useProjects();


  const {
    state: { menuOrientation }
  } = useConfig();
  // const { menuLoading } = useGetMenu();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  const [selectedID, setSelectedID] = useState<string | undefined>('');
  // const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({ items: [] });

  // let widgetMenu = Menu();

  // useLayoutEffect(() => {
  //   const isFound = menuItem.items.some((element) => {
  //     if (element.id === 'group-widget') {
  //       return true;
  //     }
  //     return false;
  //   });
  //   if (menuLoading) {
  //     menuItem.items.splice(1, 0, widgetMenu);
  //     setMenuItems({ items: [...menuItem.items] });
  //   } else if (!menuLoading && widgetMenu?.id !== undefined && !isFound) {
  //     menuItem.items.splice(1, 1, widgetMenu);
  //     setMenuItems({ items: [...menuItem.items] });
  //   } else {
  //     setMenuItems({ items: [...menuItem.items] });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [menuLoading]);

  // last menu-item to show in horizontal menu bar
  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;

  useEffect(() => setSelectedID(''), [activeProject?.id]);


  const items = useMemo(() => {
    // always start from a clean base
    const cleanBase = baseItems.filter(
      (i) => !i.id?.startsWith('project-section-')
    );

    /*const cleanBase = filterMenuByRole(
      baseItems.filter((i) => !i.id?.startsWith('project-section-')),
      role
    );*/
    //console.log(baseItems);
    //console.log(cleanBase);

    if (!activeProject) return cleanBase;

    const projectSection = buildProjectSection(
      { id: activeProject.id, name: activeProject.name },
      { runId: activeRunId, number: viewpointNumber(activeProject, activeRunId) }
    );

    // inject immutably
    return [
      ...cleanBase.slice(0, 1),
      projectSection,
      ...cleanBase.slice(1)
    ];
  }, [baseItems, activeProject, activeRunId]);



  let lastItemIndex = items.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string;

  if (lastItem && lastItem < items.length) {
    lastItemId = items[lastItem - 1].id!;
    lastItemIndex = lastItem - 1;
    remItems = items.slice(lastItem - 1, items.length).map((item) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon,
      ...(item.url && {
        url: item.url
      })
    }));
  }

  const navItems = items.slice(0, lastItemIndex + 1).map((item, index) => {
    switch (item.type) {
      case 'group':
        if (item.url && item.id !== lastItemId) {
          return (
            <List key={item.id}>
              <NavItem item={item} level={1} isParents setSelectedID={() => setSelectedID('')} />
              <Activity mode={!isHorizontal && index !== 0 ? 'visible' : 'hidden'}>
                <Divider sx={{ py: 0.5 }} />
              </Activity>
            </List>
          );
        }

        return (
          <NavGroup
            key={item.id}
            setSelectedID={setSelectedID}
            selectedID={selectedID}
            item={item}
            lastItem={lastItem!}
            remItems={remItems}
            lastItemId={lastItemId}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" align="center" sx={{ color: 'error.main' }}>
            Menu Items Error
          </Typography>
        );
    }
  });

  return !isHorizontal ? <Box {...(drawerOpen && { sx: { mt: 1.5 } })}>{navItems}</Box> : <>{navItems}</>;
}

export default memo(MenuList);
